import { useToast } from '@jaymathew/ui-shared/contexts/ToastContext'
import { useInfiniteQuery } from '@tanstack/react-query'
import getNotificationsQueryOptions, { getNotificationsOptions } from 'queryOptions/getNotifications'
import { AllowedOverrides } from 'queryOptions/queryOptionsUtils.types'

interface UseGetUsersNotificationsParams {
	params: Omit<getNotificationsOptions, 'lastDocument' | 'mode'>
	overrides?: AllowedOverrides
}

export const useGetUsersNotifications = ({
	params,
	overrides,
}: UseGetUsersNotificationsParams) => {
	const { triggerToast } = useToast()

	const queryResult = useInfiniteQuery(
		getNotificationsQueryOptions(params, overrides),
	)

	const notifications = queryResult.data?.pages.flatMap((page) => page.payload) || []
	const visible = notifications.filter(n => !n.deletedAt)

	if (queryResult.error) {
		triggerToast(`Error fetching notifications: ${queryResult.error.message}`, 'error')
	}

	return {
		...queryResult,
		notifications: visible,
	}
}
